import { render, staticRenderFns } from "./OpenTextRow.vue?vue&type=template&id=19cc7a52&scoped=true&"
import script from "./OpenTextRow.vue?vue&type=script&lang=js&"
export * from "./OpenTextRow.vue?vue&type=script&lang=js&"
import style0 from "./OpenTextRow.vue?vue&type=style&index=0&id=19cc7a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc7a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cc7a52')) {
      api.createRecord('19cc7a52', component.options)
    } else {
      api.reload('19cc7a52', component.options)
    }
    module.hot.accept("./OpenTextRow.vue?vue&type=template&id=19cc7a52&scoped=true&", function () {
      api.rerender('19cc7a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/OpenTextRow.vue"
export default component.exports